const initialState = {
    sections: [],
    loading: false,
    error: null,
};

const businessIntelligenceReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'business/get-intelligence/pending':
            return { ...state, loading: true, error: null };
        case 'business/get-intelligence/fulfilled':
            return { ...state, loading: false, sections: action.payload.data };
        case 'business/get-intelligence/rejected':
            return { ...state, loading: false, error: "No business intelligence data found." };
        default:
            return state;
    }
};

export default businessIntelligenceReducer;
